import type { IUseAccess } from 'hooks/useAccess';

import { useCallback, useMemo, useState } from 'react';

import type { WorkOrderFilterType } from '../../../WorkOrder/WorkOrderFilter/types';
import { WorkOrderFilterLevelEnum } from '../../../WorkOrder/WorkOrderFilter/types';

export enum ModalName {
    Other = 'Other',
    Price = 'Price',
    UseCoefficient = 'UseCoefficient',
}

export const useAddItemsToWorkOrderChangeMenu = ({
    filters,
    actionsDisabled,
    workOrderChangeUerRules,
}: {
    filters: WorkOrderFilterType;
    actionsDisabled: boolean;
    workOrderChangeUerRules: IUseAccess['workOrderChangeUer'];
}) => {
    const [openedModal, setOpenedModal] = useState<Partial<Record<ModalName, boolean>>>({});

    const openModalByName = useCallback((modalName: keyof typeof ModalName) => {
        setOpenedModal({ [modalName]: true });
    }, []);

    const closeModalsHandler = useCallback(() => {
        setOpenedModal({});
    }, []);

    const isPricesBtnDisabled = useMemo(
        () =>
            actionsDisabled ||
            filters?.level?.value === WorkOrderFilterLevelEnum.TOTALS ||
            !workOrderChangeUerRules?.canManualCreation,
        [actionsDisabled, filters?.level?.value, workOrderChangeUerRules?.canManualCreation],
    );

    const menuItems = useMemo(
        () => [
            {
                label: 'Расценку',
                action: () => {
                    openModalByName(ModalName.Price);
                },
                disabled: isPricesBtnDisabled,
            },
            ...(!workOrderChangeUerRules.canAddMassCoef
                ? []
                : [
                      {
                          label: 'Коэффициент',
                          action: () => {
                              openModalByName(ModalName.UseCoefficient);
                          },
                          disabled: isPricesBtnDisabled,
                      },
                  ]),
            {
                label: 'Прочие',
                action: () => {
                    openModalByName(ModalName.Other);
                },
                disabled: isPricesBtnDisabled,
            },
        ],
        [isPricesBtnDisabled, openModalByName, workOrderChangeUerRules.canAddMassCoef],
    );

    return {
        menuItems,
        openedModal,
        closeModalsHandler,
    };
};
